import { env } from '@/config/env';

export const IMPORT_INSTRUCTION_LINK = `${env.API_URL}/storage/import/import_instructions.pdf`;
export const IMPORT_STOCKS_INSTRUCTION_LINK = `${env.API_URL}/storage/import/import_stocks_instructions.pdf`;
